<template>
    <div class="screen-box" :class="{'screen-box-source18-pad': _initData.source == '18'}">
        <div class="view">
            <div class="top">
                <div class="l">
                    筛选
                    <!-- <p v-show="selectData2Str">当前条件：<span v-text="selectData2Str"></span></p>
                    <p v-show="_slideData8h.list[0].record.priceDisplay&&_initData.priceMin&&_initData.priceMax">
                        价格区间：
                        <span v-text="_initData.priceMin + '-' + _initData.priceMax + '元'"></span>
                    </p> -->
                </div>
                <div class="r iconfont" @click="$emit('_isScreenPageFun')">&#xe66c;</div>
            </div>

            <div class="swiper-box">
                <div class="swiper-view">
                <!-- <swiper :options="options" ref="mySwiper">
                    <swiperSlide v-for="(item, index) in _slideData8g.list" :key="index"> -->
                        <div class="item" v-for="(item, index) in _slideData8g.list" :key="index">
                            <h5 v-text="item.record.filterName + '：'"></h5>

                            <div class="btn-box">
                                <div class="btn-view">
                                    <!-- noSeleced -->
                                    <a class="btn" href="javaScript: void(0)" 
                                        v-for="(it, i) in item.record.filterConditionList" :key="i" 
                                        v-show="it.active"
                                        :class="{'active': it.status, 'noSeleced': it.isSelectedWM}"
                                        :title="it.filterCondition"
                                        @click="btnSelectFun(item, index, it, i)">
                                            <span>{{it.filterCondition}}</span>
                                            <!-- <span>{{it.filterCondition}}{{it.filterConditionCode}}</span> -->
                                            <img v-if="it.jumpType" @click="jumpTypeFun($event, it)" src="../../assets/jiaobiao.png" alt="">
                                        </a>
                                </div>
                            </div>
                        </div>
                    <!-- </swiperSlide>
                </swiper>
                <div class="swiper-scrollbar swiper-scrollbar-2"></div> -->
                </div>
            </div>

            <!-- <img class="shouzhi" v-show="_slideData8g.list.length>4" src="../../assets/shouzhi_hp.gif" alt=""> -->

            <div class="bottom">
                <a class="reset" href="javaScript: void(0)" @click="resultFun()">重置</a>
                <a class="result" href="javaScript: void(0)" v-show="isBtnShow === 'tuijian'" @click="$emit('_isScreenPageFun')" v-text="'查看' + _initData.count + '台推荐车'"></a>
                <a class="result select" href="javaScript: void(0)" v-show="isBtnShow === 'load'">正在查询中...</a>
                <a class="result select result-no" href="javaScript: void(0)" v-show="isBtnShow === 'noData'">暂无符合条件的推荐</a>
            </div>
        </div>

        <JumpTypeBox :_jumpData="jumpData"></JumpTypeBox>

        <transition name="slide-down">
            <Tips v-if="isTips" :isTips="isTips" @closeTips="closeTips"/>
        </transition>
    </div>
</template>

<script>
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'

import JumpTypeBox from "./jumpTypeBox.vue";
import Tips from "./tips.vue";

export default {
    props:{
        _slideData8g:{
            type: Object,
            default: {},
        }, 
        _slideData8h:{
            type: Object,
            default: {},
        },
        _isBtnShow:{
            type: String,
            default: "tuijian",
        },
        _initData:{
            type: Object,
            default: {},
        },
    },
    components: {
        // swiper, 
        // swiperSlide,
        JumpTypeBox,
        Tips
    },
    data () {
        return {
            // options: {
            //     notNextTick: true,
			// 	loop: false, // 循环
			// 	speed: 500,  // 滑动速度
			// 	centeredSlides: false,  // 若为真，那么活动块会居中，而非默认状态下的居左
			// 	slidesPerView: 4,
			// 	initialSlide: 0,
			// 	spaceBetween: 0,
			// 	preventLinksPropagation:true, //拖动释放时不会输出信息，阻止click冒泡。拖动Swiper时阻止click事件。
            //     mousewheel: false,
            //     scrollbar: {
            //         el: ".swiper-scrollbar-2",
            //         hide: false,
            //         snapOnRelease: false,
            //         draggable: true
            //     },
            // },
            ops: {
                scrollPanel: {
                    scrollingX: true,
                    scrollingY: false,
                },
                rail: {
                    opacity: 0,
                },
                bar: {
                    keepShow: true,
                    background: "#999",
                    minSize: 0.1,
                    size: '4px'
                }
            },
            selectData: {},  // 记录筛选条件code
            selectData2: {}, // 记录筛选条件文本
            selectData2Str: "",
            isBtnShow: "tuijian",
            isClick: true,
            singleShoice: null,
            initCodesArr: [],
            jumpData: {},
            isTips: false,
            // handlerHoist: [],
            btnHandlerHistory: [],
        }
    },
    created () {
        // this.handlerHoist = sessionStorage.getItem(this._initData.vehicleType + "handlerHoistIM") || "[]";
        // if(this.handlerHoist == undefined || this.handlerHoist == 'undefined' || !this.handlerHoist)
        //     this.handlerHoist = "[]"
        // this.handlerHoist = JSON.parse(this.handlerHoist);

        this.btnHandlerHistory = sessionStorage.getItem(this._initData.vehicleType + "btnHandlerHistoryIM") || "[]";
        if(this.btnHandlerHistory == undefined || this.btnHandlerHistory == 'undefined' || !this.btnHandlerHistory)
            this.btnHandlerHistory = "[]"
        this.btnHandlerHistory = JSON.parse(this.btnHandlerHistory);

        this.initCodesArr = sessionStorage.getItem(this._initData.vehicleType+"selectArrIM") ? JSON.parse( sessionStorage.getItem(this._initData.vehicleType+"selectArrIM") ) : [];
        for(let i1 in this._slideData8g.list){
            for(let i2 in this._slideData8g.list[i1].record.filterConditionList){
                this._slideData8g.list[i1].record.filterConditionList[i2].status = false;

                for(let j1 in this.initCodesArr){
                    if(this.initCodesArr[j1].filterConditionCode == this._slideData8g.list[i1].record.filterConditionList[i2].filterConditionCode && 
                        this.initCodesArr[j1].filterCondition == this._slideData8g.list[i1].record.filterConditionList[i2].filterCondition)
                        this._slideData8g.list[i1].record.filterConditionList[i2].status = true;
                }
            }
        }

        this._slideData8g.list.forEach((item, index) => {
            let result = "", result2 = "";
            item.record.filterConditionList.forEach((it, ind) => {
                if(it.status){
                    if(item.record.filterType == 0){ // 单选
                        this.selectData[index] = it.filterConditionCode;
                        this.selectData2[index] = it.filterCondition;
                    }else{ // 多选
                        if(item.record.filterType == 1){  // 多选交集
                            result += it.filterConditionCode + '/';
                        }else if(item.record.filterType == 2){  // 多选并集
                            result += it.filterConditionCode + ',';
                        }
                        result2 += it.filterCondition + '、';
                        this.selectData[index] = result.substring( 0, result.length-1 );
                        this.selectData2[index] = result2.substring( 0, result2.length-1 );
                    }   
                }
            })           
        });
        this.selectData2StrFun("init");
    },
    methods: {
        updateData8g (questionId, freezeCodes) {
            let isHave = null;
            // if(questionId == '0') {
            //     this._slideData8g.list.forEach((b, b_i) => {
            //         b.record.filterConditionList.forEach((c, c_i) => {
            //             this._slideData8g.list[b_i].record.filterConditionList[c_i].isSelectedWM = false;
            //         })
            //     })
            // } else {
                // console.log("wm--", freezeCodes);
                let arr = [];
                this._slideData8g.list.forEach((b, b_i) => {
                    b.record.filterConditionList.forEach((c, c_i) => {
                        arr = c.filterConditionCode.split(",");
                        for(let i in arr){
                            // isHave = freezeCodes.findIndex(e => e.indexOf(arr[i]) != -1);
                            isHave = freezeCodes.findIndex(e => e == arr[i]);
                            c.isSelectedWM = !!(isHave != -1)
                            // console.log("wm--", arr, c.isSelectedWM, isHave);
                            if(isHave != -1)
                                break;
                        }
                    })
                })
            // }
        },
        btnSelectFun(item, index, it, index2){  // 选择筛选条件
            if(it.isSelectedWM){
                this.isTips = true;
                return;
            }

            if(!this.isClick){
                return;
            }
            this.isClick = false;

            // this.setHandlerHoist(item, index, it, index2); // 记录问题操作顺序
            this.initStatus(item, index, it, index2);
            this.selectData2StrFun("click");
            this.selectDataArrFun();
        },
        // setHandlerHoist (item, index, it, index2) {
        //     if(this.handlerHoist.length) {
        //         let hanl_index = this.handlerHoist.findIndex(e => e.record.sort == item.record.sort)
        //         if(hanl_index != -1)
        //             this.handlerHoist.splice(hanl_index, 1);
        //     } 
        //     if(!it.status)
        //         this.handlerHoist.push(item);
        //     sessionStorage.setItem(this._initData.vehicleType + "handlerHoistIM", JSON.stringify(this.handlerHoist));
        // },
        closeTips () {
            this.isTips = false;
        },
        initStatus(item, index, it, index2){
            if(item.record.filterType == 0){  // 单选
                if(this.forArrFun(index, index2)){
                    item.record.filterConditionList[index2].status = !item.record.filterConditionList[index2].status;
                }else{
                    for(let i=0; i<item.record.filterConditionList.length; i++){ 
                        item.record.filterConditionList[i].status = false;
                    }
                    item.record.filterConditionList[index2].status = !item.record.filterConditionList[index2].status;
                }
                this.$set(this._slideData8g.list, index, item);
                
                // this.selectData[index] = this.forArrFun(index, index2) ? it.filterConditionCode : "";
                this.selectData = this.btnHandlerHistoryFun(item, it);
                this.selectData2[index] = this.forArrFun(index, index2) ? it.filterCondition : "";
            }else{  // 多选
                item.record.filterConditionList[index2].status = !item.record.filterConditionList[index2].status;
                this.$set(this._slideData8g.list, index, item);

                let result = "", result2 = "";
                for(let j=0; j<item.record.filterConditionList.length; j++){
                    if(item.record.filterConditionList[j].status){
                        if(item.record.filterType == 1){  // 多选交集
                            result += item.record.filterConditionList[j].filterConditionCode + '/';
                        }else if(item.record.filterType == 2){  // 多选并集
                            result += item.record.filterConditionList[j].filterConditionCode + ',';
                        }
                        result2 += item.record.filterConditionList[j].filterCondition + '、';
                    }        
                }
                // this.selectData[index] = result.substring( 0, result.length-1 );
                this.selectData = this.btnHandlerHistoryFun(item, it);
                this.selectData2[index] = result2.substring( 0, result2.length-1 );
            }
            console.log("wm", item, this.selectData, this.selectData2);
        },
        btnHandlerHistoryFun (o, o_c) {  // 记录且按照用户操作顺序计算结果
            let i = this.btnHandlerHistory.findIndex(e => e.record.sort == o.record.sort);

            if(o.record.filterType == 0) {  // 单选
                if(i != -1)
                    this.btnHandlerHistory.splice(i, 1);

                if(o_c.status)  // 选中
                    this.btnHandlerHistory.push(o);
            } else {  // 多选
                let isSC = o.record.filterConditionList.findIndex( e => e.status == true );
                if(i == -1) {
                    if(o_c.status) 
                        this.btnHandlerHistory.push(o);
                } else {
                    if(isSC == -1) {
                        this.btnHandlerHistory.splice(i, 1);
                    } else {
                        this.btnHandlerHistory[i] = o;
                    }
                }
            }
            
            sessionStorage.setItem(this._initData.vehicleType + "btnHandlerHistoryIM", JSON.stringify(this.btnHandlerHistory));
            let res = {};
            this.btnHandlerHistory.length && this.btnHandlerHistory.forEach((e, e_i) => {
                let dxRes = "";
                e.record.filterConditionList.forEach(c => {
                    if(e.record.filterType == 0) {  // 单选
                        if(c.status)
                            res[e_i] = c.filterConditionCode;
                    } else {  // 多选
                        if(c.status) {
                            dxRes += c.filterConditionCode + "/";
                            res[e_i] = dxRes;
                        }
                    }
                })  
                if(e.record.filterType == 1) 
                    res[e_i] = res[e_i].substring( 0, res[e_i].length - 1);
            })
            
            return res;
        },
        forArrFun(index, index2){
            let arr = this._slideData8g.list[index].record.filterConditionList;
            let status = false;
            for(let i=0; i<arr.length; i++){
                if(arr[i].status && i==index2){
                    status = true;
                    break;
                }
            }
            return status;
        },
        selectDataArrFun(val){
            let selectArr = [];
            for(let i in this._slideData8g.list){
                for(let j in this._slideData8g.list[i].record.filterConditionList){
                    if(this._slideData8g.list[i].record.filterConditionList[j].active && this._slideData8g.list[i].record.filterConditionList[j].status){
                        selectArr.push(
                            this._slideData8g.list[i].record.filterConditionList[j]
                        );
                    }
                }
            }
            
            sessionStorage.setItem(this._initData.vehicleType+"selectArrIM", JSON.stringify(selectArr));
            sessionStorage.setItem("selectArrIM", JSON.stringify(selectArr));
        },
        selectData2StrFun(val){
            this.selectData2Str = "";
            for(let k in this.selectData2){
                if(this.selectData2[k]){
                    this.selectData2Str += this.selectData2[k] + "、";
                }
            }

            this.selectData2Str = this.selectData2Str.substring( 0, this.selectData2Str.length-1 );
            if(val == "click") this.submitFun();
        },
        submitFun(){  // 筛选条件提交
            let params = {
                featureCodes: "",
                productCode: this._slideData8h.list[0].record.productCode,
                screenNum: this.screenCountFun(),
            };
            for(let key in this.selectData){
                if(this.selectData[key]){
                    params.featureCodes += this.selectData[key] + ";";
                }
            }
            
            params.featureCodes = params.featureCodes.substring( 0, params.featureCodes.length-1 );

            this.$emit('_submitFun', params, "screenPage");
            this.isBtnShow = "load";
        },
        screenCountFun(){
            let sd8g = this._slideData8g;
            let count = 0;
            for(let i=0; i<sd8g.list.length; i++){
                for(let j=0; j<sd8g.list[i].record.filterConditionList.length; j++){
                    if(sd8g.list[i].record.filterConditionList[j].status){
                        count++;
                    }
                }
            }
            return count;
        },
        resultFun(){  // 重置按钮
            for(let i1 in this._slideData8g.list){
                for(let i2 in this._slideData8g.list[i1].record.filterConditionList){
                    this._slideData8g.list[i1].record.filterConditionList[i2].status = false;
                    this.$set(this._slideData8g.list, i1, this._slideData8g.list[i1]);
                }
            }
            this.selectData = {};
            this.selectData2 = {};
            this.selectData2Str = "";

            sessionStorage.setItem(this._initData.vehicleType + "btnHandlerHistoryIM", "[]");
            sessionStorage.setItem(this._initData.vehicleType + "selectArrIM", "[]")
            sessionStorage.setItem(this._initData.vehicleType + "httpParamsIM", "{}");
            sessionStorage.setItem("httpParamsIM", "{}");

            let params = {
                featureCodes: "A03C",
                productCode: this._slideData8h.list[0].record.productCode,
            };
            this.$emit('_submitFun', params, "screenPage");
        },
        jumpTypeFun(e, item){
            e.stopPropagation();
            if(!item.jumpType)
                return;
            if(item.jumpType == 1){
                if(item.targetType == 1)  // 文章
                    window.open(item.articleUrl);
                else if(item.targetType == 2)  // 图片
                    window.open(item.imageUrl);
                else if(item.targetType == 3)  // 视频
                    window.open(item.videoUrl);
                return;
            }
            // jumpType 等于2和3
            this.jumpData = {
                isShow: true,
                ...item
            };
        },
    },
    watch: {
        _isBtnShow: {  // 监听父组件状态变化 实时更新按钮状态
            handler( val, oldVal){
                let _this = this;
                setTimeout(function(){
                    _this.isClick = true;
                    _this.isBtnShow = val.substring(0, val.indexOf("&"));
                }, 500);
            }
        }
    },
}
</script>

<style lang="less" src="../../stylesNewUI/pc.less"></style>
<style lang="less">
@import "../../stylesNewUI/animate.less";

</style>
